'use client'

import React, { useEffect, useState } from 'react'

interface Prop {
    companyName: string
}

const CopyrightLine = ({ companyName }: Prop) => {
    const [currentYear, setCurrentYear] = useState('')

    useEffect(() => {
        setCurrentYear(new Date().getFullYear().toString())
    }, [])

    return (
        <>
            &copy; {currentYear} {companyName}. All rights reserved.
        </>
    )
}

export default CopyrightLine
